'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of woman
 */ const Woman = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3477_3605)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M52.1286 61.5317C49.4203 61.5317 46.7915 60.9998 44.3158 59.9509C41.9257 58.9382 39.7794 57.4891 37.937 55.6437C36.0946 53.7984 34.6479 51.6486 33.6368 49.2546C32.5896 46.7745 32.0586 44.1418 32.0586 41.4288C32.0586 38.7158 32.5896 36.0831 33.6368 33.6033C34.6479 31.2093 36.0946 29.0595 37.937 27.2141C39.7794 25.3688 41.9257 23.9197 44.3158 22.907C46.7915 21.8581 49.4203 21.3262 52.1286 21.3262C54.8369 21.3262 57.4657 21.8581 59.9414 22.907C62.3315 23.9197 64.4778 25.3688 66.3202 27.2141C68.1626 29.0595 69.6093 31.2093 70.6204 33.6033C71.6676 36.0831 72.1986 38.7161 72.1986 41.4288C72.1986 44.1415 71.6676 46.7745 70.6204 49.2543C69.6093 51.6483 68.1626 53.7981 66.3202 55.6434C64.4778 57.4888 62.3315 58.9379 59.9414 59.9506C57.4654 60.9995 54.8369 61.5314 52.1286 61.5314V61.5317ZM52.1286 26.1798C43.7338 26.1798 36.9044 33.0206 36.9044 41.4288C36.9044 49.837 43.7341 56.6777 52.1286 56.6777C60.5232 56.6777 67.3528 49.837 67.3528 41.4288C67.3528 33.0206 60.5232 26.1798 52.1286 26.1798Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M50.8281 58.9434H53.1077V80.909H50.8281V58.9434Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M54.8639 57.1895H49.0781V82.6673H54.8639V57.1895Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M42.5 73.0044V71.1895H61.4248V73.0044H42.5Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M63.1813 69.4355H40.75V74.7627H63.1813V69.4355Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3477_3605",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "40.1403",
                        height: "61.3333",
                        fill: "white",
                        transform: "translate(32.0625 21.3379)"
                    })
                })
            })
        ]
    });
};

exports.Woman = Woman;
//# sourceMappingURL=Woman.cjs.map
